import { gql } from '@apollo/client';
import { CARRIER_INVOICE_FIELDS } from '@/graphql/queries/carrier_invoices';
import { CLAIM_ADJUSTMENT_FIELDS } from '@/graphql/fragments/claim_adjustments';
import { SUPPLEMENTAL_CHARGE_FIELDS } from '@/graphql/fragments/supplemental_charges';

export const INVOICE_ORDER_FIELDS = gql`
    fragment InvoiceOrderFields on orders {
        order_id
        order_number
        po_number
        reference_id
        pod
        delivery_photo
        customer_signature
        order_revenue
        carrier_rate
        middle_mile_carrier_rate
        warehouse_carrier_rate
        contractor_rate
        price_breakdown
        qbo_tag
        invoice_class
    }
`;

export const INVOICE_FIELDS = gql`
    ${CARRIER_INVOICE_FIELDS}
    ${CLAIM_ADJUSTMENT_FIELDS}
    ${SUPPLEMENTAL_CHARGE_FIELDS}
    ${INVOICE_ORDER_FIELDS}

    fragment InvoiceFields on carrier_invoices {
        ...CarrierInvoiceFields

        supplemental_charges {
            ...SupplementalChargeFields
        }

        claim_adjustments {
            ...ClaimAdjustmentFields
            claim {
                claim_id
                order {
                    ...InvoiceOrderFields
                }
            }
        }

        client {
            client_id
            business_name
        }

        partner_client {
            client_id
            business_name
        }

        organization {
            organization_id
            name
        }

        orders {
            ...InvoiceOrderFields
        }

        middle_mile_carrier_orders {
            ...InvoiceOrderFields
        }

        warehouse_carrier_orders {
            ...InvoiceOrderFields
        }

        contractor_orders {
            ...InvoiceOrderFields
        }
    }
`;

export const INVOICES = gql`
    ${INVOICE_FIELDS}
    query GetInvoices($where: carrier_invoices_bool_exp!, $limit: Int!, $offset: Int!) {
        results: carrier_invoices(
            where: $where
            order_by: { created_at: desc_nulls_last }
            limit: $limit
            offset: $offset
        ) {
            ...InvoiceFields
        }
    }
`;

export const UPDATE_INVOICES = gql`
    ${CARRIER_INVOICE_FIELDS}
    mutation UpdateInvoices($ids: [uuid!]!, $patch: carrier_invoices_set_input!) {
        updated: update_carrier_invoices(where: { carrier_invoice_id: { _in: $ids } }, _set: $patch) {
            returning {
                ...CarrierInvoiceFields
            }
        }
    }
`;
